import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "I have no investing experience — is this for me?",
    a: "Yes. The Portfolio Kickstart is built exactly for that. We start from zero — opening a brokerage, picking your first positions, and building habits that actually make your money grow.",
  },
  {
    q: "What kind of returns are we talking about?",
    a: "Strong, long-term oriented. My portfolio is built on conviction picks with solid open returns and an average holding period of around two years. I'll walk you through real numbers — not screenshots — on our call.",
  },
  {
    q: "How much do I need to start?",
    a: "Honestly, less than people think. The point isn't how much you start with — it's getting your money out of a 0% savings account and into something that compounds.",
  },
  {
    q: "Why don't you list prices?",
    a: "Because everyone shows up with a different situation. Pricing varies based on what you actually need — a one-off portfolio build is very different from ongoing mentorship. Reach out and we'll find the right fit.",
  },
  {
    q: "You're 17 — why should I trust you with my money?",
    a: "You shouldn't hand anyone your money. I don't manage your account — I teach you, walk you through decisions, and share what's actually in my own portfolio. Three years of consistent research and real returns speaks louder than my age.",
  },
  {
    q: "Is this financial advice?",
    a: "No. It's education and mentorship. Everything we work on is to help you make informed decisions yourself — not to act as a licensed advisor.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-32 lg:py-40 border-t border-white/5"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.35em] text-amber-500 mb-6">
            — FAQ
          </p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
            Questions, <em className="italic text-amber-400">answered.</em>
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="w-full border-t border-white/10"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-serif-display text-xl sm:text-2xl text-white hover:no-underline text-left py-6 hover:text-amber-400 transition-colors">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed text-base pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
